<template>
  <v-card flat>
    <v-card-text class="pa-7 position-relative">
      <!-- لودینگ اتمی -->
      <v-overlay :value="fetchingData" absolute opacity="0.4" color="white">
        <atom-spinner
          :animation-duration="1500"
          :size="100"
          class="mx-auto"
          color="indigo"
        />
      </v-overlay>

      <v-form ref="form" v-model="valid">
        <v-row>
          <!-- کف قیمت: در ویرایش قفل است، در ساخت قابل ورود است -->
          <v-col cols="12" md="4" v-if="isEdit">
            <PriceInput
              v-model="form.min_unit_price"
              label="کف قیمت (ریال)"
              prepend-inner-icon="mdi-arrow-down-circle-outline"
              outlined
              dense
              :readonly="isEdit"
              :disabled="isEdit"
              :rules="[v => !!v || 'وارد کردن کف قیمت الزامی است']"
            />
          </v-col>

          <!-- سقف قیمت: در ویرایش قفل است، در ساخت قابل ورود است -->
          <v-col cols="12" md="4" v-if="isEdit">
            <PriceInput
              v-model="form.max_unit_price"
              label="سقف قیمت (ریال)"
              prepend-inner-icon="mdi-arrow-up-circle-outline"
              outlined
              dense
              :readonly="isEdit"
              :disabled="isEdit"
              :rules="[v => !!v || 'وارد کردن سقف قیمت الزامی است']"
            />
          </v-col>

          <!-- ابعاد و زمان‌ها -->
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="form.lead_time"
              type="number"
              label="زمان آماده‌سازی (روز)"
              prepend-inner-icon="mdi-clock-time-four-outline"
              outlined
              dense
              min="0"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="form.seller_lead_time"
              type="number"
              label="زمان آماده‌سازی فروشنده (ساعت)"
              prepend-inner-icon="mdi-timer-sand"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <!-- درصد سود -->
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="form.profit_percent"
              type="number"
              label="درصد سود"
              prepend-inner-icon="mdi-chart-line"
              suffix="%"
              outlined
              dense
              min="0"
              max="100"
              :rules="[
                v => (v !== '' && v !== null && v !== undefined) || 'وارد کردن درصد سود الزامی است',
                v => (Number(v) >= 0 && Number(v) <= 100) || 'درصد سود باید بین ۰ تا ۱۰۰ باشد'
              ]"
            ></v-text-field>
          </v-col>

          <!-- مبنای اعمال درصد سود -->
          <!-- <v-col cols="12" md="4">
            <v-select
              v-model="form.profit_target_price"
              :items="profitTargetOptions"
              item-text="text"
              item-value="value"
              label="مبنای اعمال سود"
              prepend-inner-icon="mdi-target"
              outlined
              dense
              :rules="[v => !!v || 'انتخاب مبنای اعمال سود الزامی است']"
            />
          </v-col> -->

          <!-- درصدها و هزینه‌ها -->
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="form.commission_percent"
              type="number"
              label="درصد کمیسیون"
              prepend-inner-icon="mdi-percent-outline"
              suffix="%"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="form.tax_percent"
              type="number"
              label="درصد مالیات"
              prepend-inner-icon="mdi-bank-outline"
              suffix="%"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <!-- پردازش پلتفرم -->
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="form.processing_fee_percent"
              type="number"
              label="درصد پردازش"
              prepend-inner-icon="mdi-percent-outline"
              suffix="%"
              outlined
              max="100"
              min="0"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <PriceInput
              v-model="form.processing_fee_min"
              label="حداقل هزینه پردازش"
              prepend-inner-icon="mdi-cash-minus"
              outlined
              min="0"
              dense
            />
          </v-col>
          <v-col cols="12" md="4">
            <PriceInput
              v-model="form.processing_fee_max"
              label="حداکثر هزینه پردازش"
              prepend-inner-icon="mdi-cash-plus"
              outlined
              dense
              :min="form.processing_fee_min"
            />
          </v-col>

          <!-- سوئیچ‌ها -->
          <v-col cols="12" md="4">
            <v-switch
              v-model="form.is_active"
              label="فعال‌سازی وضعیت قیمت"
              prepend-icon="mdi-power-plug-outline"
              color="success"
              inset
              dense
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="px-5 py-3">
      <v-btn class="btn-delete rounded-lg px-5" :disabled="loading" @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
        انصراف
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        class="btn-get-code rounded-lg"
        :loading="loading"
        :disabled="!valid || fetchingData"
        @click="saveSmartPricingSettings"
      >
        <v-icon right class="ml-1">mdi-content-save</v-icon>
        ذخیره تنظیمات
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PriceInput from "../../../../core/plugins/TitleRibbon/pages/pickers/priceInput.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "settingTabshop",
  components: { PriceInput, AtomSpinner },
  props: {
    product_id: {
      type: [Number, String],
      required: true,
      default:null,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    store_id:{
      type:Number,
      default:null
    }
  },
  data() {
    return {
      loading: false,
      fetchingData: false,
      valid: false,

      strategies: [],
      profitTargetOptions: [
        { text: "کف قیمت (حداقل)", value: "min" },
        { text: "سقف قیمت (حداکثر)", value: "max" },
      ],
      shippingTypes: [
        { text: "توسط پلتفرم", value: "platform" },
        { text: "توسط فروشنده", value: "seller" },
      ],

      form: this.getDefaultForm(),
    };
  },

  watch: {
    product_id: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (this.isEdit) {
            this.fetchPricingSettings();
          } else {
            this.form = this.getDefaultForm();
          }
        }
      }
    }
  },

  created() {
    this.fetchStrategies();
  },

  methods: {
    getDefaultForm() {
      return {
        product_id: this.product_id||null,
        is_active: true,
        min_unit_price: "",
        max_unit_price: "",
        profit_percent: 0,
        profit_target_price: "min",
        commission_percent: 15.0,
        tax_percent: 10.0,
        post_shipping_fee: 0,
        processing_fee_percent: 7,
        processing_fee_min: 360000,
        processing_fee_max: 2400000,
        lead_time: 1,
        seller_lead_time: 2,
      };
    },

    async fetchPricingSettings() {
      this.fetchingData = true;
      try {
        const response = await this.$api.get(
          `/v1/marketplace/pricing-settings`,{ params:{store_id:this.store_id}}
        );
        const data = response.data?.data || response.data?.result || response.data;

        if (data && typeof data === "object") {
          this.form = {
            ...this.getDefaultForm(),
            ...data,
            profit_percent: data.profit_percent !== undefined && data.profit_percent !== null
              ? Number(data.profit_percent)
              : 0,
            profit_target_price: data.profit_target_price || "min",
            product_id: this.product_id,
          };
        } else {
          this.form = this.getDefaultForm();
        }
      } catch (error) {
        this.form = this.getDefaultForm();
      } finally {
        this.fetchingData = false;
      }
    },

    async fetchStrategies() {
      try {
        const response = await this.$api.get("/v1/smart-pricing-strategies?page=1&length=500000");
        if(!response?.data||response?.data?.data)
        this.strategies =[];
      else
        this.strategies = response.data?.data?.data || response.data?.data || response.data || [];
      } catch (error) {
        console.error("خطا در دریافت استراتژی‌ها", error);
      }
    },

    async saveSmartPricingSettings() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      const cleanNumber = (val) => (val ? Number(String(val).replace(/,/g, "")) : 0);

      const payload = {
        product_id: this.product_id,
        is_active: Boolean(this.form.is_active),
        min_unit_price: cleanNumber(this.form.min_unit_price),
        max_unit_price: cleanNumber(this.form.max_unit_price),
        profit_percent: Number(this.form.profit_percent || 0),
        profit_target_price: this.form.profit_target_price || "min",
        commission_percent: Number(this.form.commission_percent || 15),
        tax_percent: Number(this.form.tax_percent || 10),
        processing_fee_percent: Number(this.form.processing_fee_percent || 7),
        processing_fee_min: cleanNumber(this.form.processing_fee_min || 360000),
        processing_fee_max: cleanNumber(this.form.processing_fee_max || 2400000),
        lead_time: Number(this.form.lead_time || 1),
        seller_lead_time: Number(this.form.seller_lead_time || 2),
        store_id: this.store_id||null
      };

      try {
        await this.$api.post(`/v1/marketplace/pricing-settings`, payload);
        this.$toast.success("تنظیمات قیمت و ارسال با موفقیت ذخیره شد.");
        this.$emit("saved");
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "خطا در ذخیره تنظیمات");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
